import { getCountryTranslation } from '../services/countriesTranslationsService';
import { getRegionTranslation } from '../services/regionsTranslationsService';
import { getAcademyTranslation } from '../services/academiesTranslationsService';
import { getDistrictTranslation } from '../services/districtsTranslationsService';
import { getInstitutionTranslation } from '../services/institutionsTranslationsService';
import { getDepartmentTranslation } from '../services/departmentsTranslationsService';

/** يطابق رموز اللغة مع مفاتيح ملفات الترجمة */
function toOrgLang(lang) {
  if (lang === 'ar' || lang === 'fr' || lang === 'en') return lang;
  return 'ar';
}

/**
 * يترجم مقطعاً واحداً من المسار التنظيمي (بلد، جهة، …) باستخدام خدمات الترجمة المعتمدة في المشروع.
 */
export function translateOrgPathSegment(segment, currentLanguage) {
  const L = toOrgLang(currentLanguage);
  const s = (segment || '').trim();
  if (!s) return s;

  const translators = [
    (n) => getCountryTranslation(n, L),
    (n) => getRegionTranslation(n, L),
    (n) => getAcademyTranslation(n, L),
    (n) => getDistrictTranslation(n, L),
    (n) => getInstitutionTranslation(n, L),
    (n) => getDepartmentTranslation(n, L)
  ];

  for (const fn of translators) {
    const out = fn(s);
    if (out !== s) return out;
  }
  return s;
}

/**
 * يترجم سلسلة `deepest_org_path` بالكامل (فاصل `>` أو ` > `).
 */
export function translateDeepestOrgPath(path, currentLanguage) {
  if (!path || typeof path !== 'string') return path;
  const trimmed = path.trim();
  if (!trimmed) return trimmed;

  const parts = trimmed.split(/\s*>\s*/).map((p) => p.trim()).filter(Boolean);
  if (parts.length === 0) return trimmed;

  const translated = parts.map((seg) => translateOrgPathSegment(seg, currentLanguage));
  return translated.join(' > ');
}
